// extracted by mini-css-extract-plugin
export var root = "K_wz";
export var wrapper = "K_wB";
export var image = "K_wC d_w d_y d_W";
export var imageWithHeight = "K_wD";
export var crop = "K_wF";
export var round = "K_wG";
export var fixedHeight = "K_wH";